import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap';
import { useAuth } from '../../context/ContextData';

const DealerConnectModal = (props) => {
    const { setGetDealerId } = useAuth();
    const [btnClr, setBtnClr] = useState({
        step1: 'bg_green_clr',
        step2: '',
    });
    const [dealerID, setDealerID] = useState("");
    const [pinCode, setPinCode] = useState("");

    const [dealers, setDealers] = useState([])

    useEffect(() => {
        if (dealerID.length === 10 || pinCode.length === 6) {
            var myHeaders = new Headers();
            myHeaders.append("wu-platform", process.env.REACT_APP_USER_SECRET);
            myHeaders.append("Content-Type", "application/json");

            var raw = JSON.stringify({
                "dealerId": dealerID,
                "pincode": pinCode
            });

            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: raw,
                redirect: 'follow'
            };

            fetch(process.env.REACT_APP_URL + "customer/dealerConnect", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "success") {
                        setDealers(result.data)
                    }
                })
                .catch(error => console.log('error', error));
        }

    }, [dealerID, pinCode,])

    return (
        <React.Fragment>
            <Modal show={props.show} onHide={() => props.setShow(false)} className="br_10 popupwrapper mm_model1 tw_center" centered >
                <Modal.Body className="cp pb-5 px-2">
                    <div onClick={() => props.setShow(false)} className="closemark_icon mouse fw-bold">&#x2715;</div>
                    <h1 className="cpm text-center">Dealer Connect</h1>
                    <p className="text-center fs12">Once you connect with dealer you always go with that</p>

                    <div className="tw_center">
                        <div className="border rounded-pill W_fit p-1">
                            <label onClick={() => { setBtnClr({ step1: 'bg_green_clr' }); setPinCode('') }} className={`${btnClr.step1} mouse py-2 px-4 rounded-pill cpm`}>Dealer ID</label>
                            <label onClick={() => { setBtnClr({ step2: 'bg_green_clr', step1: '' }); setDealerID('') }} className={`${btnClr.step2} mouse py-2 px-4 rounded-pill cpm`}>Location</label>
                        </div>
                    </div>
                    {btnClr.step1 ?
                        <input
                            type="number"
                            className="my-4 w-100 border-0 px-4 py-2 rounded-pill pro_de_model"
                            placeholder="Enter Dealer ID"
                            value={dealerID}
                            onChange={(e) => setDealerID(e.target.value)}
                            onInput={(e) => e.target.value = e.target.value.slice(0, 10)}
                        /> : <input
                            type="number"
                            className="my-4 w-100 border-0 px-4 py-2 rounded-pill pro_de_model"
                            placeholder="Enter Pincode"
                            value={pinCode}
                            onChange={(e) => setPinCode(e.target.value)}
                            onInput={(e) => e.target.value = e.target.value.slice(0, 6)}
                        />}
                    <img src="/assets/icons/search.png" alt="search" className="mouse position-absolute end-0 mt-4 pt-2 me-3" />

                    {/* {btnClr.step1 ?
                        <div className="text-start">
                            {
                                dealer ?
                                    <div className="mb-2 rounded d-flex w-100 p-2 border mouse"
                                        onClick={() => {
                                            localStorage.setItem("dealerId", dealer.dealerId);
                                            localStorage.setItem("storeName", dealer.storeName);
                                            setGetDealerId(dealer.storeName);
                                            props.setShow(false);
                                        }}
                                    >
                                        {!dealer.profileImage ?
                                            <div className="me-2 mainCharBg cpm rounded-circle">
                                                {dealer.storeName.charAt(0).toUpperCase()}
                                            </div> :
                                            <div className="me-2 psc">
                                                <img src={process.env.REACT_APP_S3URL + dealer.profileImage} alt="dealer" height={90} width={90} className="rounded-circle " />
                                            </div>
                                        }
                                        <div>
                                            <h4 className="cpm fs14 mb-1"> {dealer.storeName}</h4>
                                            <h6 className="fs_13 mb-1">Deals in: {dealer.selectedProduct.map(obj => obj.product_name) + ","}</h6>
                                            <h6 className="fs_13 mb-1">Mob: +91-{dealer.mobile},
                                                Whatsapp: +91-{dealer.whatsapp && dealer.whatsapp}</h6>
                                            <h6 className="fs_13 mb-0">Address: {dealer.street} {dealer.city}</h6>
                                        </div>
                                    </div>
                                    : <div className="text-center fw-bold fs_20 mb-4">No Data Found</div>
                            }
                        </div>
                        : */}
                        <div className="text-start">
                            {
                                dealers.length > 0 ?
                                    dealers.map((item, index) => (
                                        <div key={index} className="mb-2 rounded d-flex w-100 p-2 border mouse"
                                            onClick={() => {
                                                localStorage.setItem("dealerId", item.dealerId);
                                                localStorage.setItem("storeName", item.storeName);
                                                setGetDealerId(item.storeName)
                                                props.setShow(false)
                                            }}
                                        >
                                            {!item.profileImage ?
                                                <div className="me-2 mainCharBg cpm rounded-circle">
                                                    {item.storeName.charAt(0).toUpperCase()}
                                                </div> :
                                                <div className="me-2 psc">
                                                    <img src={process.env.REACT_APP_S3URL + item.profileImage} alt="dealer" height={90} width={90} className="rounded-circle " />
                                                </div>
                                            }
                                            <div>
                                              <h4 className="cpm fs14 mb-1"> {item.storeName}</h4>
                                                <h6 className="fs_13 mb-1">Deals in: {item.products.map((x, i) => <span key={i}>{x}, </span>)}</h6>
                                                   <h6 className="fs_13 mb-1">Mob: +91-{item.mobile && item.mobile.toString().slice(0, 3) + "XXXX" + item.mobile.toString().slice(7, 10)},
                                                    Whatsapp: +91-{item.whatsapp && item.whatsapp.toString().slice(0, 3) + "XXXX" + item.whatsapp.toString().slice(7, 10)}</h6>
                                                <h6 className="fs_13 mb-0">Address: {item.address}</h6>
                                            </div>
                                        </div>
                                    )) : 
                                    (dealerID.length !==10 && pinCode.length !==6) ? <div className="text-center fw-bold fs_20 mb-4">Search</div>
                                    : dealers.length ===0 &&
                                    <div className="text-center fw-bold fs_20 mb-4">No Data Found</div>
                            }

                        </div>
                    {/* // } */}
                </Modal.Body>
            </Modal>
        </React.Fragment>
    )
}

export default DealerConnectModal
